export default __webpack_public_path__ + "static/media/grp2_w1024.9f3aeb6a.jpeg";